import React, { useContext } from 'react';

import { useSelector } from 'react-redux';
import { ConditionalRendering } from '../../../../../components/common/conditional-rendering';
import { INPUT_TYPES } from '../../../../../components/common/form/constants/fieldTypes';
import { APPLICATION_TYPES } from '../../../../../constants/enrollmentList/enrollmentList.constant';
import { usePermissions } from '../../../../../hooks/usePermissions';
import Dropdown from '../../../../../lib/inputs/Dropdown';
import { IEnrollmentPremiumDto } from '../../common/types';
import { EnrollmentContext } from '../../context/MemberMyEnrollmentProvider';

const ColumnApplicationType = ({ premium }: { premium: IEnrollmentPremiumDto }) => {
    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { userPermissions } = permissions || {};
    const { viewEditableFields } = usePermissions();
    const { enableContinueButton, enrollmentPremiumFormContext, selectedEnrollment } = useContext(EnrollmentContext);
    const { watch, setValue } = enrollmentPremiumFormContext;
    const values = watch();

    const updateApplicationType = (premium, value) => {
        values.enrollmentPremiumDtoList.map((el: IEnrollmentPremiumDto, index) => {
            if (premium.month === el.month) {
                let updatedEnrollment = el;
                if (value === 'Financial') {
                    updatedEnrollment = {
                        ...el,
                        isAptcEligible: true,
                        isFinancial: true,
                    };
                } else {
                    updatedEnrollment = {
                        ...el,
                        aptcAmount: 0,
                        maxAptc: 0,
                        netPremiumAmount: parseFloat(premium.grossPremiumAmount),
                        stateSubsidyAmount: 0,
                        maxStateSubsidy: 0,
                        isFinancial: false,
                    };
                }

                setValue(`enrollmentPremiumDtoList.${index}`, updatedEnrollment, {
                    shouldDirty: true,
                    shouldValidate: true,
                });

                return;
            }
        });

        enableContinueButton();
    };

    return (
        <ConditionalRendering isTrue={viewEditableFields(userPermissions, values, premium)}>
            <Dropdown
                label={{
                    text: '',
                    labelClass: [''],
                }}
                inputData={{
                    inputClasses: [''],
                    options: APPLICATION_TYPES,
                    type: INPUT_TYPES.DROPDOWN,
                    value: premium.isFinancial ? 'Financial' : 'Non-Financial',
                    isInputRequired: false,
                    disabled: values.isItf,
                }}
                inputActions={{
                    handleFieldChange: value => updateApplicationType(premium, value),
                }}
            />
        </ConditionalRendering>
    );
};

export default ColumnApplicationType;
